export default "/build/images/HomwCarIMG2.png?3284ca0f36ed75cf436b69cfb245b930";